module.exports = __webpack_public_path__ + "static/media/header.0a0e0e34.mp3";